<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
        <!-- <div class="modal__logo-title">Seguro Desk</div> -->
      </div>

      <div class="modal__main-icon modal__main-icon--mandat"></div>
      <div class="modal__back" @click="goBack()"></div>
      <div class="modal__close" @click="closeModal()"></div>

      <div class="form form--terminate">
        <div class="navigators">
          <div class="navigator navigator--active">
            <div class="navigator__bullet"></div>
            <div class="navigator__title">
              {{ $t(`addMandateModal.${"title"}`) }}
            </div>
          </div>
        </div>
        <div class="add__form">
          <transition name="fade" mode="out-in">
            <Loading v-if="formLoading" />
            <div v-else class="add__content">
              <div class="termination">
                <div class="termination__row">
                  <div class="termination__column">
                    <div class="form__field">
                      <div class="input input--default input--readonly">
                        {{ parseCustomerName(customerDetails) }}
                      </div>
                    </div>

                    <div class="form__field">
                      <VSelect class="select select--default" :options="agents" :reduce="(agent) => agent.id"
                        :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`" v-model="agentId"
                        :placeholder="$t(`addMandateModal.${'agent'}`)" />
                    </div>

                    <div class="form__field">
                      <VSelect class="select select--default" :class="{ 'select--error': mandateHasError }"
                        :options="mandates" :reduce="(mandate) => mandate.id"
                        :getOptionLabel="(mandate) => `${mandate.name} `"
                        :placeholder="$t(`addMandateModal.${'mandate'}`)" v-model="mandateTypeId" />
                      <div class="form__error" v-if="mandateHasError">
                        {{ $t(`addMandateModal.${"mandateErrorMsg"}`) }}
                      </div>
                    </div>

                    <div class="form__field">
                      <VSelect class="select select--default" :options="agents" :reduce="(agent) => agent.id"
                        :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`" v-model="noticeAgentId"
                        :placeholder="$t(`addMandateModal.${'noticeAgent'}`)" />
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading"></div>
      <div v-else>
        <button class="modal__button modal__button--submit button button--default" @click="addMandate()">
          <span>{{ $t(`addMandateModal.${'saveBtn'}`) }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/partials/Loading";
import { parseCustomerName } from "@/helpers/entityParsers";
import { mapGetters } from "vuex";
import statics from "@/statics";
export default {
  name: "AddMandateModal",

  components: {
    Loading,
  },

  data() {
    return {
      parseCustomerName,
      formLoading: true,
      isRequesting: false,
      statics,

      customerId: "",
      mandateTypeId: "",

      agentId: null,
      noticeAgentId: null,

      mandateHasError: false,
    };
  },

  watch: {
    mandateTypeId(value) {
      if (value) {
        this.mandateHasError = false;
      } else {
        this.mandateHasError = true;
      }
    },
  },

  computed: {
    ...mapGetters([
      "customerDetails",
      "mandateForms",
      "loggedUser",
    ]),

    agents() {
      return this.mandateForms.agents;
    },

    mandates() {
      return this.mandateForms.mandate_types;
    },
  },

  async created() {
    this.formLoading = true; 

    if (this.customerDetails.team) {
      this.teamId = Number(this.customerDetails.team.id);
      await this.$store.dispatch("getMandateForms", this.teamId);
    }

    this.customerId = this.customerDetails.id; 
    this.formLoading = false;
  },

  destroyed() {
    this.closeModal();
  },

  methods: {
    closeModal() {
      this.$store.commit("setShowAddMandateModal", false);
    },

    goBack() {
      this.closeModal();
      this.$store.commit("setShowAddActivityModal", true);
    },


    validateFields(callback) {
      if (this.mandateTypeId) {
        this.mandateHasError = false;
      } else {
        this.mandateHasError = true;
      }


      if (!this.mandateHasError) {
        callback(true);
      } else {
        callback(false);
      }
    },
    async addMandate() {
      this.isRequesting = true;

      this.validateFields(async (isValid) => {
        if (!isValid) {
          this.$store.commit("setToast", {
            display: true,
            type: "error",
            message: this.$t(`addMandateModal.${'validationErrorMsg'}`),
          });
          this.isRequesting = false;
          return;
        }

        try {
          await this.$store.dispatch('createMandate', {
            customer_id: this.customerId,
            mandate_type_id: this.mandateTypeId,
            agent_id: this.agentId,
            notice_agent_id: this.noticeAgentId,
          });
          this.closeModal();
        } catch (error) {
          console.error("Action failed:", error);
        } finally {
          this.isRequesting = false;
        }
      });
    },

  },
};
</script>

<style scoped lang="scss">
@import "../assets/scss/_termination-potential-policy.scss";

.modal__panel {
  max-width: 600px !important;
}

.add__form {
  width: 100% !important;
}

.custom-duration-wrapper {

  background-color: var(--bg-3);

  color: var(--text-3);
  padding: 0 10px;
  font-size: var(--x-small);
  border-radius: var(--radius-1);
  font-family: var(--muli-text-semi-bold);
  border: 1px solid transparent;


  display: flex;
  align-items: center;
  padding: 0;

}

.custom-duration {
  background-color: transparent;
  //  border: 1px solid ;
  height: 40px;
  color: var(--text-3);

  font-size: var(--x-small);
  text-align: center;
  font-family: var(--muli-text-semi-bold);
}


::v-deep .vue__time-picker input.display-time {
  width: 100%;
  padding: .3em .5em;
  font-size: 1em;
  height: 100%;
  background-color: transparent;
  border: none;
  text-align: center;
  color: var(--text-2);
  font-family: var(--muli-text-semi-bold);
}

.termination__row {
  border: 0;
}

.form__field__call__duration {
  margin-top: -8px;
}

.call__duration__label {
  margin-bottom: -6px;
}

[data-theme="dark"] .call__duration__label {
  p {
    color: white;
  }
}


.call__duration__label p {
  color: #7F8FA480;
  font-size: 14px;
}


.call__duration__types {
  display: flex;
  gap: 12px;
}


.call__duration__value {
  color: #B9C2CD;
  font-size: 16px;
  cursor: pointer;
}


.call__duration__value--active {
  color: #22DB8E;
}

.termination__textarea__row {
  margin-top: -40px;
}

.form__notes__textarea {
  width: 66%;
}


.custom-time-input {
  position: relative;
  width: 48%;
}

.custom-input {
  appearance: none;
  color: var(--text-2);
  background-color: var(--bg-3);
  border-radius: 10px;
  padding: 0 10px;
  height: 40px;
  font-size: 16px;
  width: 100%;
  box-sizing: border-box;
}

.custom-input::placeholder {
  font-family: var(--muli-text-semi-bold);
  color: var(--text-8);
}


.date-picker {
  width: 48%;
  position: relative;
  z-index: 1;
}

.date-time-wrapper {
  display: flex;
  justify-content: space-between;
}
</style>
